<template>
  <div>
    <loading :active.sync="isLoading"></loading>
    <div class="labelaudio__audio">
      <div class="audio">
        <div class="audio__wave" id="waveform"></div>
        <div class="audio__playlist">
          <button class="btn btn-primary audio__playlist--play" @click.prevent="play()">
            <i class="fas fa-play"></i> /
            <i class="fas fa-pause"></i>
          </button>
          <button class="btn btn-danger audio__playlist--stop" @click.prevent="stop()">
            <i class="fas fa-stop"></i>
          </button>
          <p class="audio__playlist--wavname">{{audioName}}</p>
          <p class="audio__playlist--date">{{batchDate}}</p>
        </div>
      </div>
      <div
        class="audio__interval"
        v-for="(item,index) in label"
        :key="index"
        :style="{backgroundColor:item.color}"
      >
        <div class="audio__interval--time">{{index +1}}. {{item.status}} &rarr; {{item.time}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import * as WaveSurfer from 'wavesurfer.js';
import * as WaveSurferRegions from 'wavesurfer.js/dist/plugin/wavesurfer.regions';
import * as WaveSurferCursors from 'wavesurfer.js/dist/plugin/wavesurfer.cursor';

export default {
  props: {
    PropsAudioUrl: String,
    PropsStatus: String,
    PropsBatchDate: String,
    PropsAudioName: String,
    PropsHasLabeled: Array,
    PropsPlay: null,
  },
  data() {
    return {
      dataToParents: [], // 準備給 父component 資料
      audioUrl: null,
      status: null, // cry, talk, cry&talk, music, echo, other
      batchDate: null,
      audioName: null,
      hasLabeled: [], // 若父組件原本有資料 就會接說父組件丟過來的資料
      isLoading: false,
      barHeight: '6',
      label: [], // 已標記的陣列
      labelColor: '#7fffd470',
      statusDecideColor: {
        talk: '#ff00003d',
        cry: '#7fffd470',
        cry_talk: '#9932cc3b',
        echo: '#f0e68c78',
        music: 'rgba(0, 128, 0, 0.2)',
        other: '#6495ed61',
      },
      colorDecideStatus: {
        '#ff00003d': 'talk',
        '#7fffd470': 'cry',
        '#9932cc3b': 'cry_talk',
        '#f0e68c78': 'echo',
        'rgba(0, 128, 0, 0.2)': 'music',
        '#6495ed61': 'other',
      },
    };
  },
  methods: {
    createToParentData() {
      const vm = this;
      vm.dataToParents = vm.label;
    },
    play() {
      // 播放音檔
      this.wavesurfer.playPause();
    },
    stop() {
      // 停止音檔
      this.wavesurfer.stop();
    },
    // 繪製標記區域  ＊henry 調整內部架構
    changeDrawingRegionColor() {
      const vm = this;
      vm.labelColor = vm.statusDecideColor[vm.status];
      vm.wavesurfer.regions.color = vm.labelColor;
    },
    updateLabels() {
      // push value in vm.label
      const vm = this;
      vm.label = [];
      const road = vm.wavesurfer.container.childNodes[2]; // region label data
      const count = road.children.length - 1;
      for (let k = 2; k <= count; k += 1) {
        vm.label.push({
          status: road.children[k].getAttribute('status'),
          id: road.children[k].getAttribute('data-id'),
          time: road.children[k].getAttribute('title'),
          color: road.children[k].getAttribute('color'),
          start: road.children[k].getAttribute('start'),
          end: road.children[k].getAttribute('end'),
        });
      }
    },
    destroyWavesurfer() {
      const vm = this;
      vm.wavesurfer.destroy();
      vm.wavesurfer.clearRegions();
    },
    // 繪製波行
    drawWave() {
      const vm = this;
      vm.isLoading = true;
      // const options = {
      //   headers: {
      //     token: localStorage.token,
      //   },
      // };
      // fetch(vm.audioUrl, options)
      //   .then((res) => res.blob())
      //   .then((blob) => {
      //     vm.wavesurfer.load(URL.createObjectURL(blob));
      //     vm.isLoading = false;
      //   });
      const urlData = {
        BatchDate: vm.PropsBatchDate,
        BatchType: 'audio',
        ImgOrAudioName: vm.PropsAudioName,
      };
      vm.$store.dispatch('getImgOrAudioWithToken', urlData).then((response) => {
        vm.wavesurfer.load(URL.createObjectURL(response));
        vm.isLoading = false;
      });

      vm.setupWavesurfer();
      if (vm.hasLabeled.length !== 0) {
        vm.drawRegion(vm.hasLabeled);
      }
    },
    created(data) {
      // 用來創建被標記過的audio data
      const vm = this;
      const road = vm.wavesurfer.container.childNodes[2];
      for (let k = 0; k < data.length; k += 1) {
        const color = vm.statusDecideColor[data[k].class];
        road.children[k + 2].setAttribute('start', data[k].start_ms);
        road.children[k + 2].setAttribute('end', data[k].end_ms);
        road.children[k + 2].setAttribute('status', data[k].class);
        road.children[k + 2].setAttribute('color', color);
      }
      vm.updateLabels();
    },
    setupWavesurfer() {
      const vm = this;
      vm.wavesurfer = WaveSurfer.create({
        container: '#waveform', // 區域
        height: '200', // 高度,
        hideScrollbar: true,
        cursorColor: 'red', // 進度線條顏色
        backend: 'MediaElement',
        barWidth: true,
        barHeight: vm.barHeight,
        plugins: [
          WaveSurferCursors.create({
            showTime: true,
            opacity: 0.8,
            customShowTimeStyle: {
              'background-color': '#000',
              color: '#fff',
              padding: '5px',
              'font-size': '16px',
            },
          }),
          WaveSurferRegions.create({
            dragSelection: {
              slop: 5,
            },
            color: vm.labelColor,
            status: vm.status,
          }),
        ],
      });
      vm.wavesurfer.on('region-created', (region) => {
        region.color = vm.labelColor;
      });

      vm.wavesurfer.on('region-update-end', (region) => {
        vm.dom = true;
        const road = vm.wavesurfer.container.childNodes[2];
        region.status = vm.colorDecideStatus[region.color];

        const count = road.children.length - 1; // 指到當前region label index
        // 移動當前現有label box
        for (let i = 0; i < vm.label.length; i += 1) {
          if (region.id === vm.label[i].id) {
            road.children[i + 2].setAttribute(
              'start',
              Math.floor(region.start * 1000),
            );
            road.children[i + 2].setAttribute(
              'end',
              Math.floor(region.end * 1000),
            );
            road.children[i + 2].setAttribute('status', region.status);
            road.children[i + 2].setAttribute('color', region.color);
          }
        }

        if (count - 1 !== vm.label.length) {
          road.children[count].setAttribute(
            'start',
            Math.floor(region.start * 1000),
          );
          road.children[count].setAttribute(
            'end',
            Math.floor(region.end * 1000),
          );
          road.children[count].setAttribute('status', region.status);
          road.children[count].setAttribute('color', region.color);
        }

        vm.updateLabels();
      });

      vm.wavesurfer.on('region-dblclick', (region) => {
        region.remove();
        vm.updateLabels();
      });
    },
    drawRegion(segments) {
      const vm = this;
      for (let i = 0; i < segments.length; i += 1) {
        vm.labelColor = vm.statusDecideColor[segments[i].class];

        vm.wavesurfer.addRegion({
          start: segments[i].start_ms / 1000,
          end: segments[i].end_ms / 1000,
          color: vm.labelColor,
        });
        vm.label = [];

        if (i === segments.length - 1) {
          vm.created(segments);
        }
      }
    },
  },
  watch: {
    PropsStatus() {
      this.status = this.PropsStatus;
      this.changeDrawingRegionColor();
    },
    PropsBatchDate() {
      this.batchDate = this.PropsBatchDate;
    },
    PropsAudioName() {
      this.label = [];
      this.audioUrl = this.PropsAudioUrl;
      this.batchDate = this.PropsBatchDate;
      this.audioName = this.PropsAudioName;
      this.hasLabeled = this.PropsHasLabeled;
      this.destroyWavesurfer();
      this.drawWave();
    },
    label() {
      const vm = this;
      vm.createToParentData();
      vm.$emit('feedbackDataToParent', vm.dataToParents);
    },
    PropsPlay() {
      this.play();
    },
  },
  mounted() {
    this.setupWavesurfer();
  },
};
</script>
